import { ThemeInstance } from "./ThemeInstance";
import Env from 'env';

//import * as Form from 'components/Form';

//import * as Geo from 'lib/geo';

export class LiteTheme extends ThemeInstance {

    //
    // Colors
    //
    themeColor = '#25afce';
    errorColor = '#ff0000';

    //
    // Layout
    //




    //pageBackgroundColor = '#F5F5F5';  // White Smoke
    pageBackgroundColor = '#FFF8DC';  // Corn silk
    //pageTextColor = '#2d2d30';  // VS Code dark theme color
    pageTextColor = '#1F3F3f';  // VS Code dark theme color


    //
    // Button styling
    //
    //authButtonSize = new Geo.Size(120, 32);
    authGreetingWidth = 200;

    //navButtonSize = new Geo.Size(140, 40);
    navButtonGap: number;



    //
    // Dialog and Form elements
    //

    dialogBorderRadius = 4;
    dialogBorderWidth = 2;
    dialogBorderColor = this.themeColor;
    dialogBorderStyle = 'solid';
    dialogMessageTransform = 'translateY(-8vh)';
    dialogBackgroundColor = '#ffffff';

    cssDialogBorder() {
        return {
            borderRadius: this.dialogBorderRadius,
            borderColor: this.dialogBorderColor,
            borderWidth: this.dialogBorderWidth,
            borderStyle: this.dialogBorderStyle,
        }
    }

    smallInputWidth = 80;

    //
    // Input elements
    //
    inputTextBackgroundColor = '#ffffff';
    inputReadonlyBackgroundColor = '#eeeeee';


    //
    // Display grid
    //
    tableActionButtonWidth = 60; //Env.isDesktop ? 90 : 80;
    tableActionButtonHeight = 60;
    tableOddRowColor = '#eeeeee';

    constructor() {
        super();

        this.navButtonGap = this.muiSpacing * 2;
    }


};
